define( '../src/journeys/j01-transaction-history/j01-transaction-history',[ 'jquery' ], function ( $ ) {

	'use strict';

	var transHistory = function ( $journey ) {

		this.$journey = $journey;

		return this;
	};

	transHistory.prototype.init = function () {

		this.toggleDate();

	};

	transHistory.prototype.toggleDate = function() {
		var _this = this;

		$('.j01-transaction-history-select').find('.form-field__input--radio').each(function() {
			$(this).on('click', function() {
				if ( $(this).val() == 'custom' ) {
					$('.j01-transaction-history-selectdate').show();
					$('.j01-transaction-history-selectdate').find('.form-field__input--datepicker').each(function(){
						$(this).attr('required', true);
					});

				} else {
					$('.j01-transaction-history-selectdate').hide();
					$('.j01-transaction-history-selectdate').find('.form-field__input--datepicker').each(function(){
						$(this).removeAttr('required');
						$(this).parsley().reset();
						$(this).parent().removeClass('form-field__input-wrapper--error');
					});
				};
			});
		});
	};

	return transHistory;
} );

